import styled from 'styled-components';
import { InfoTitle } from '../../../components/Toolkit/InfoTitle/InfoTitle';
import { TextField } from '../../../components/Toolkit/Inputs/TextField';
import { Select } from '../../../components/Toolkit/Inputs/Select';
import { Notification } from '../../../components/Toolkit/Notification/Notification';
import { OpenOutlineIc } from '@dsch/dd-icons';
import { BaseModal as Modal } from '../../../components/Toolkit/Modal/BaseModal';

export const Header = styled(InfoTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const Input = styled(TextField)`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

export const SNotification = styled(Notification)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const SSelect = styled(Select)`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

export const Legal = styled.p`
  ${({ theme }) => theme.fontSize.S10};
  margin: 0 auto ${({ theme }) => theme.spacing.M16};
  text-align: center;
  max-width: 80%;
  line-height: 16px;
`;

export const TakeAction = styled.div`
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  margin-bottom: ${({ theme }) => theme.spacing.M24};
  line-height: 16px;
`;

export const SpacedDivider = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY};
  gap: ${({ theme }) => theme.spacing.S8};
  margin: ${({ theme }) => theme.spacing.M16} auto;

  &:before,
  &:after {
    content: '';
    flex: 1 0 auto;
    height: 1px;
    background: ${({ theme }) => theme.colors.GREY};
  }
`;

export const AdditionalInfoText = styled.p`
  ${({ theme }) => theme.fontSize.B12};
`;

export const SOpenOutlineIc = styled(OpenOutlineIc)`
  margin-left: ${({ theme }) => theme.spacing.S4};
`;

export const BaseModal = styled(Modal)`
  max-height: 100vh;
`;
